import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';

const UsageLocationsField = ({
    darkMode,
    serviceWizard,
    options,
    walkthroughId,
    errors,
    touched,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.filterLocations && touched.filterLocations}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{
                    ...stackStyling(true),
                    height: 'fit-content',
                    padding: '10px 0px',
                }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Usage Locations
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select usage locations for sync
                    </Text>
                </Box>
                <Box width="100%">
                    <DropDown
                        name="filterLocations"
                        data={(options || []).map((o) => ({
                            id: o.value,
                            name: o.label,
                        }))}
                        shownValue="name"
                        isMulti
                        multiValue={
                            Array.isArray(serviceWizard?.filterLocations)
                                ? serviceWizard.filterLocations.map((loc) =>
                                      typeof loc === 'string'
                                          ? loc
                                          : loc?.value,
                                  )
                                : []
                        }
                        darkMode={darkMode}
                        width="100%"
                        placeholder="- Select regions -"
                        walkthroughId={walkthroughId}
                        handleSelectChange={(ids) => {
                            const selected = (ids || [])
                                .map((id) =>
                                    (options || []).find(
                                        (opt) => opt.value === id,
                                    ),
                                )
                                .filter(Boolean);
                            serviceWizard.updateLocations(selected);
                        }}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the usage locations to sync"
                        ariaLabel="usage-locations-field-tip"
                        left="25px"
                        top="15px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default UsageLocationsField;
